import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { howCinchWorks, howCinchWorksFAQs } from "../../../data/how-cinch-works";
import { parentLinks } from "../../../data/parent-menu";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { ListItem } from "../list-item/list-item";
import { ListWrapper } from "../list-wrapper/list-wrapper";
import { HowCinchWorksListItems } from "./how-cinch-works-items";
import styles from "./how-cinch-works-menu.module.css";
export var HowCinchWorksMenu = function(param) {
    var setShouldShowMobileMenu = param.setShouldShowMobileMenu, handleFaqClick = param.handleFaqClick;
    var ref = useContext(SharedUiHeaderV2Context), logicStore = ref.logicStore, shouldShowStoreMegaNav = ref.shouldShowStoreMegaNav;
    var handleTrackEvent = logicStore.handleTrackEvent;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                className: styles.listContainer,
                "data-testid": "how-cinch-works-dropdown-menu",
                children: /*#__PURE__*/ _jsx(ListWrapper, {
                    heading: parentLinks.HOWCINCHWORKS,
                    isListCard: false,
                    children: /*#__PURE__*/ _jsx(HowCinchWorksListItems, {
                        navItems: howCinchWorks.navItems,
                        handleTrackEvent: handleTrackEvent,
                        shouldShowStoreMegaNav: shouldShowStoreMegaNav
                    })
                })
            }),
            /*#__PURE__*/ _jsx("nav", {
                className: styles.faqContainer,
                children: /*#__PURE__*/ _jsx(ListWrapper, {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    heading: howCinchWorksFAQs.sectionTitle,
                    urlText: howCinchWorksFAQs.sectionLink,
                    href: howCinchWorksFAQs.href,
                    isListCard: true,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.HOWCINCHWORKS,
                            action: "FAQ",
                            value: howCinchWorksFAQs.sectionLink
                        });
                    },
                    children: /*#__PURE__*/ _jsx(Fragment, {
                        children: howCinchWorksFAQs.faqs.map(function(faq) {
                            return /*#__PURE__*/ _jsx("li", {
                                className: styles.faqList,
                                children: /*#__PURE__*/ _jsx(ListItem, {
                                    label: faq.label,
                                    href: faq.href,
                                    ariaLabel: faq.ariaLabel,
                                    handleClickEvent: function() {
                                        handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.HOWCINCHWORKS,
                                            action: "FAQ",
                                            value: "default - ".concat(faq.label)
                                        });
                                        // handleFaqClick solve the scroll issue on desktop
                                        handleFaqClick && handleFaqClick(null);
                                        if (setShouldShowMobileMenu) {
                                            setShouldShowMobileMenu();
                                        }
                                    }
                                }, faq.label)
                            }, faq.label);
                        })
                    })
                })
            })
        ]
    });
};
